import * as React from 'react';

const ShowSetting: React.SFC<{
    children: React.ReactNode;
    keyName: string;
    setting: any;
}> = (props) => {
    const { keyName, setting } = props;
    if (!!setting[keyName]) {
        return <React.Fragment>{props.children}</React.Fragment>;
    }
    return null;
};

export default ShowSetting;
